import React from 'react';

const Twilio = React.lazy(() => import('./Twilio'));

export default Twilio;